(() => {
  'use strict';
  const config = window.NF || {root:'/',strings:{}};
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const $ = (selector, within=document) => within.querySelector(selector);
  const $$ = (selector, within=document) => [...within.querySelectorAll(selector)];
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  const announce = text => { const el = $('#SiteStatus'); if (el) el.textContent = text; };
  let cartBusy = false;
  const variantRequests = new WeakMap();
  const openDialog = dialog => { if (dialog && !dialog.open) dialog.showModal(); };
  const setPending = (scope, state) => {
    scope.setAttribute('aria-busy', String(state));
    $$('button[type="submit"],button[name="checkout"],input[data-cart-quantity]', scope).forEach(el => {
      if (state) { el.dataset.wasDisabled = String(el.disabled); el.disabled = true; }
      else if ('wasDisabled' in el.dataset) { el.disabled = el.dataset.wasDisabled === 'true'; delete el.dataset.wasDisabled; }
    });
  };
  async function jsonRequest(path, body) {
    const options = {method:'POST',headers:{Accept:'application/json'},body};
    if (!(body instanceof FormData)) {
      options.headers['Content-Type']='application/json';
      options.body=JSON.stringify(body);
    }
    const response = await fetch(root + path, options);
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : config.strings.error);
    return data;
  }
  const sectionIds = () => [...new Set($$('[data-cart-render]').map(el => el.dataset.cartRender))];
  function renderCart(sections) {
    let found = 0;
    $$('[data-cart-render]').forEach(el => {
      const activeId = el.contains(document.activeElement) ? document.activeElement.id : '';
      const oldNote = $('[data-cart-note]',el);
      const noteDraft = oldNote && oldNote.value !== oldNote.defaultValue ? oldNote.value : null;
      const noteOpen = oldNote?.closest('details')?.open;
      const markup = sections?.[el.dataset.cartRender];
      if (!markup) return;
      const incoming = $('[data-cart-content]', parse(markup));
      if (!incoming) return;
      el.replaceChildren(incoming);
      const newNote = $('[data-cart-note]',el);
      if(newNote && noteDraft !== null)newNote.value=noteDraft;
      if(newNote && noteOpen)newNote.closest('details').open=true;
      if(activeId)document.getElementById(activeId)?.focus({preventScroll:true});
      found++;
    });
    const count = $('[data-cart-content]')?.dataset.itemCount;
    if (count !== undefined) $$('[data-cart-count]').forEach(el => el.textContent = count);
    return found === sectionIds().length;
  }
  async function refreshCart(data) {
    if (data.sections && renderCart(data.sections)) return;
    const url = new URL(root + 'cart', location.origin);
    url.searchParams.set('sections', sectionIds().join(','));
    const response = await fetch(url, {headers:{Accept:'application/json'}});
    if (!response.ok || !renderCart(await response.json())) throw new Error(config.strings.error);
  }
  async function cartMutation(path, payload, errorScope) {
    if (cartBusy) return;
    const dialogId = errorScope?.closest('dialog')?.id;
    cartBusy = true;
    $$('[data-cart-render]').forEach(el => setPending(el, true));
    try {
      const result = await jsonRequest(path, {...payload,sections:sectionIds(),sections_url:root+'cart'});
      await refreshCart(result);
      announce($('#CartDrawer h2')?.textContent || 'Bag updated');
      return result;
    } catch (error) {
      try { await refreshCart({}); } catch {}
      const scope = dialogId ? document.getElementById(dialogId) : document;
      const target = $('[data-cart-error]', scope);
      if (target) target.textContent = error.message || config.strings.cartError;
      $$('[data-cart-quantity]').forEach(el => el.value = el.dataset.original);
    } finally {
      cartBusy = false;
      $$('[data-cart-render]').forEach(el => setPending(el, false));
    }
  }
  function selectMedia(gallery, id) {
    if (!gallery || !$('[data-media-id="'+CSS.escape(String(id))+'"]',gallery)) return;
    if(!['square','portrait'].includes(gallery.dataset.mediaShape)){
      const selected=$('[data-media-id="'+CSS.escape(String(id))+'"]',gallery);
      gallery.style.setProperty('--media-ratio',String(Number(selected.dataset.aspectRatio)||1));
    }
    $$('[data-media-id]',gallery).forEach(el => {
      el.hidden = el.dataset.mediaId !== String(id);
      if (el.hidden) $$('video',el).forEach(video=>video.pause());
      if (el.hidden) $$('iframe',el).forEach(frame=>{
        if (frame.src.includes('youtube')) frame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), new URL(frame.src).origin);
        if (frame.src.includes('vimeo')) frame.contentWindow?.postMessage(JSON.stringify({method:'pause'}), new URL(frame.src).origin);
      });
    });
    $$('[data-media-target]',gallery).forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.mediaTarget===String(id))));
  }
  async function selectVariant(link) {
    const section = link.closest('[data-product-section]');
    variantRequests.get(section)?.abort();
    const controller = new AbortController();
    variantRequests.set(section,controller);
    const current = $('[data-product-buy]',section);
    const url = new URL(link.href);
    if (url.origin !== location.origin) { location.assign(url); return; }
    const selectedHref = url.pathname + url.search;
    const sameProduct = url.pathname === section.dataset.productUrl;
    if (!sameProduct) { location.assign(url); return; }
    setPending(current,true);
    $$('button[form]',current).forEach(el=>el.disabled=true);
    const error = $('[data-variant-error]',section);
    if (error) error.textContent='';
    url.searchParams.set('section_id',section.dataset.sectionId);
    try {
      const response = await fetch(url,{signal:controller.signal});
      if (!response.ok) throw new Error();
      const doc = parse(await response.text());
      const next = $('[data-product-buy]',doc);
      if (!next) throw new Error();
      if (controller.signal.aborted) return;
      const quantity = $('input[name="quantity"]', current)?.value || '1';
      const previousPlan = $('[data-selling-plan]',current)?.value;
      current.replaceWith(next);
      const planSelect=$('[data-selling-plan]',next);
      if(planSelect && previousPlan !== undefined && [...planSelect.options].some(option=>option.value===previousPlan))planSelect.value=previousPlan;
      syncPlanPrice(next);
      const input = $('input[name="quantity"]',next);
      if (input) {
        const minimum = Number(input.min) || 1;
        const maximum = Number(input.max) || Infinity;
        const step = Number(input.step) || 1;
        input.value = String(Math.max(minimum,Math.min(maximum,minimum+Math.floor((Number(quantity)-minimum)/step)*step)));
      }
      selectMedia($('[data-gallery]',section),next.dataset.selectedMedia);
      const canonical = new URL(selectedHref,location.origin);
      if (next.dataset.variantId) { canonical.searchParams.delete('option_values'); canonical.searchParams.set('variant',next.dataset.variantId); }
      if(planSelect?.value)canonical.searchParams.set('selling_plan',planSelect.value);
      history.replaceState({},'',canonical.pathname+canonical.search);
      const replacementLink = $$('[data-option-link]',next).find(el=>el.getAttribute('href')===link.getAttribute('href') && el.textContent===link.textContent);
      replacementLink?.focus({preventScroll:true});
      announce($('.price',next)?.textContent || $('.stock-status',next)?.textContent || config.strings.variantError);
      document.dispatchEvent(new CustomEvent('nf:variant-change',{detail:{variantId:next.dataset.variantId,sectionId:section.dataset.sectionId}}));
      window.Shopify?.PaymentButton?.init?.();
    } catch (e) {
      if (e.name==='AbortError') return;
      const variant = $('input[name="id"]',current);
      if (variant) { variant.value=''; variant.disabled=true; }
      $$('button[type="submit"],button[form]',current).forEach(el=>el.disabled=true);
      if (error) error.textContent=config.strings.variantError;
      current.setAttribute('aria-busy','false');
    }
  }
  document.addEventListener('click', async event => {
    const opener = event.target.closest('[data-open-dialog]');
    if (opener) { openDialog(document.getElementById(opener.dataset.openDialog)); return; }
    const closer = event.target.closest('[data-close-dialog]');
    if (closer) { closer.closest('dialog')?.close(); return; }
    if (event.target instanceof HTMLDialogElement) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom) event.target.close();
    }
    const cartLink = event.target.closest('[data-open-cart]');
    if (cartLink && config.cartDrawer) { event.preventDefault(); openDialog($('#CartDrawer')); return; }
    const option = event.target.closest('[data-option-link]');
    if (option && !event.metaKey && !event.ctrlKey && !event.shiftKey) { event.preventDefault(); selectVariant(option); return; }
    const media = event.target.closest('[data-media-target]');
    if (media) { selectMedia(media.closest('[data-gallery]'),media.dataset.mediaTarget); return; }
    const zoom = event.target.closest('[data-zoom-src]');
    if (zoom) {
      const dialog = $('[data-zoom-dialog]',zoom.closest('[data-gallery]'));
      $('[data-zoom-image]',dialog).src=zoom.dataset.zoomSrc;
      openDialog(dialog); return;
    }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) { event.preventDefault(); if (!cartBusy) await cartMutation('cart/change.js',{id:remove.closest('[data-cart-item]').dataset.key,quantity:0},remove); }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (form.matches('[data-product-form]')) {
      event.preventDefault();
      if (cartBusy || form.getAttribute('aria-busy')==='true') return;
      if (!form.reportValidity()) return;
      const body = new FormData(form);
      if (!body.get('id')) return;
      body.set('sections',sectionIds().join(','));body.set('sections_url',root+'cart');
      const error = $('[data-form-error]',form);if(error)error.textContent='';
      const pendingScope=form.closest('[data-product-buy]') || form;
      cartBusy=true;setPending(pendingScope,true);
      try {
        const result=await jsonRequest('cart/add.js',body);
        try { await refreshCart(result); } catch { location.assign(root+'cart'); return; }
        if(config.cartDrawer)openDialog($('#CartDrawer'));else location.assign(root+'cart');
      } catch(e) {
        try { await refreshCart({}); } catch {}
        if(error)error.textContent=e.message || config.strings.error;
      }
      finally { cartBusy=false;setPending(pendingScope,false); }
      return;
    }
    if (form.matches('[data-discount-form]')) {
      event.preventDefault();
      const dialogId = form.closest('dialog')?.id;
      const discount = new FormData(form).get('discount').trim();
      const result = await cartMutation('cart/update.js',{discount},form);
      if (result && discount && result.discount_codes?.some(code=>!code.applicable)) {
        const scope = dialogId ? document.getElementById(dialogId) : document;
        const error = $('[data-cart-error]',scope); if(error)error.textContent=config.strings.discountRejected;
      }
      return;
    }
    if (form.matches('[data-cart-form]')) {
      if(cartBusy){event.preventDefault();return;}
      if(event.submitter?.name==='checkout')return;
      event.preventDefault();
      await cartMutation('cart/update.js',{note:$('[data-cart-note]',form)?.value || ''},form);
    }
  });
  function syncPlanPrice(scope){
    const select=$('[data-selling-plan]',scope);
    if(!select)return;
    const priceTemplate=$$('[data-plan-price]',scope).find(el=>el.dataset.planPrice===select.value);
    if(!priceTemplate)return;
    $('[data-price-display]',scope)?.replaceChildren(priceTemplate.content.cloneNode(true));
    const sticky=$('[data-sticky-price]',scope);if(sticky)sticky.textContent=priceTemplate.dataset.money;
  }
  document.addEventListener('change',event=>{
    const input=event.target;
    if(input.matches('[data-selling-plan]')){
      syncPlanPrice(input.closest('[data-product-buy]'));
      const url=new URL(location.href);
      if(input.value)url.searchParams.set('selling_plan',input.value);else url.searchParams.delete('selling_plan');
      history.replaceState({},'',url.pathname+url.search);
    }
    if(input.matches('[data-cart-quantity]')){
      if(!input.reportValidity() || cartBusy){input.value=input.dataset.original;return;}
      cartMutation('cart/change.js',{id:input.closest('[data-cart-item]').dataset.key,quantity:Number(input.value)},input);
    }
  });
  let searchTimer,searchController;
  document.addEventListener('input',event=>{
    const input=event.target;
    if(!input.matches('[data-predictive-search] input[name="q"]'))return;
    clearTimeout(searchTimer);searchController?.abort();
    const output=$('#PredictiveResults');
    if(input.value.trim().length<2){output.replaceChildren();return;}
    searchTimer=setTimeout(async()=>{
      searchController=new AbortController();
      const url=new URL(root+'search/suggest',location.origin);
      url.searchParams.set('q',input.value.trim());url.searchParams.set('resources[type]','product');url.searchParams.set('resources[limit]','5');url.searchParams.set('section_id','predictive-search');
      output.setAttribute('aria-busy','true');
      try {
        const response=await fetch(url,{signal:searchController.signal});
        if(!response.ok)throw new Error();
        const doc=parse(await response.text());
        const results=$('.predictive-results',doc);
        output.replaceChildren(...(results?[results]:[]));
      } catch(e) { if(e.name!=='AbortError')output.replaceChildren(); }
      finally{output.setAttribute('aria-busy','false');}
    },220);
  });
  async function loadRecommendations(el) {
    if(el.dataset.loaded)return;el.dataset.loaded='true';
    try{
      const response=await fetch(el.dataset.url);if(!response.ok)return;
      const incoming=$('[data-recommendations]',parse(await response.text()));
      if(incoming?.querySelector('.product-grid'))el.replaceChildren(...incoming.childNodes);
    }catch{el.dataset.loaded='';}
  }
  function moveFilters(){
    const details=$('#CollectionFilters'),dialog=$('#FilterDialog');
    if(!details||!dialog)return;
    const form=$('.filter-form',details)||$('.filter-form',dialog);
    if(!form)return;
    if(matchMedia('(max-width: 749px)').matches)$('[data-filter-slot]',dialog).append(form);
    else {dialog.close();details.append(form);details.open=true;}
  }
  matchMedia('(max-width: 749px)').addEventListener('change',moveFilters);
  function init(scope=document){
    $$('[data-product-buy]',scope).forEach(syncPlanPrice);
    $$('[data-recommendations]',scope).forEach(el=>{
      if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){observer.disconnect();loadRecommendations(el);}},{rootMargin:'300px'});observer.observe(el);}else loadRecommendations(el);
    });
    moveFilters();
    $$('model-viewer',scope).forEach(el=>{
      if(window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0',onLoad:()=>{if(window.Shopify.ModelViewerUI&&!el.dataset.enhanced){new window.Shopify.ModelViewerUI(el);el.dataset.enhanced='true';}}}]);
    });
  }
  document.addEventListener('toggle',event=>{
    if(event.target.matches?.('.mega')&&event.target.open)$$('.mega[open]').forEach(el=>{if(el!==event.target)el.open=false;});
  },true);
  document.addEventListener('keydown',event=>{if(event.key==='Escape')$$('.mega[open],.filter-group[open]').forEach(el=>el.open=false);});
  document.addEventListener('click',event=>{$$('.mega[open],.filter-group[open]').forEach(el=>{if(!el.contains(event.target))el.open=false;});});
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>{$$('dialog[open]',event.target).forEach(dialog=>dialog.close());});
  document.addEventListener('shopify:block:select',event=>{event.target.closest('details')?.setAttribute('open','');});
  init();
})();
